import { useCallback, useState } from 'react';

export const useStack = <T>(
  defaultValue: T[]
): [T | undefined, () => void, () => void] => {
  const [activeIndex, setActiveIndex] = useState(0);
  const shift = useCallback(
    () => setActiveIndex(activeIndex + 1),
    [activeIndex]
  );
  const reset = useCallback(() => setActiveIndex(0), []);

  return [defaultValue[activeIndex], shift, reset];
};
